import styled from '@emotion/styled';

import { BREAKPOINTS } from '@/styles/themes/default';
import { IThemeProps } from '@/styles/themes/types';

import { H1 } from '../core/Heading';

export const StyledHeader = styled.header<IThemeProps>`
  margin-top: -104px;
  padding: 176px 0 56px;
  background: radial-gradient(
    98.44% 95.14% at -0.8% 0%,
    #f563ff 0%,
    rgba(8, 255, 255, 0.5) 10.76%,
    rgba(15, 255, 231, 0.35) 30%,
    rgba(255, 120, 147, 0.1) 55%,
    rgba(0, 5, 15, 0) 86%
  );
  background-color: ${({ theme }) => theme.legacy.colors.black};

  ${H1} {
    color: ${({ theme }) => theme.legacy.colors.white};
  }

  @media (min-width: ${BREAKPOINTS.Tablet.min}px) {
    margin-top: -64px;
    padding-top: 128px;
  }

  @media (min-width: ${BREAKPOINTS.Desktop.min}px) {
    padding: 154px 0 40px;
  }
`;
